import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './app/App'
import { Analytics } from '@vercel/analytics/react'
import './i18n'
import '@/styles/globals.css'
import { installChunkLoadRecovery } from '@/lib/chunk-load-recovery'

installChunkLoadRecovery()

// Sentry integration disabled - uncomment and install @sentry/react if needed
// import * as Sentry from '@sentry/react'
// if (import.meta.env.VITE_SENTRY_DSN) {
//   Sentry.init({
//     dsn: import.meta.env.VITE_SENTRY_DSN,
//     environment: import.meta.env.VITE_APP_ENV || 'development',
//     integrations: [
//       new Sentry.BrowserTracing(),
//       new Sentry.Replay(),
//     ],
//     tracesSampleRate: 0.1,
//     replaysSessionSampleRate: 0.1,
//     replaysOnErrorSampleRate: 1.0,
//   })
// }

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
    {/* debug defaults to true in dev and logs page views to the console */}
    <Analytics debug={false} />
  </React.StrictMode>,
)